import * as React from "react";

function NoMode() {
	// console.log("SeriesImageMaker");
	// console.log(mode);

	return (
		<div id="noMode">
			<h1>Choose a mode</h1>
			<img src="./logo-300x300.png" />
		</div>
	);
}

export default NoMode;
